// extracted by mini-css-extract-plugin
export default {"content_width":"DragableContainer_content_width__C4e5f"};